import React from "react"
import "./Terms.css"

function Terms() {
  return (
    <div className="Terms">
      <h1>Terms and Conditions</h1>
      <h2>OVERVIEW</h2>
      <p>
        By using the App (Qarabao) and/or Site (Qarabao.com) in any manner
        including, but not limited to, visiting or browsing, the users agree to
        be bound by this Agreement, including those additional terms, conditions
        and policies referenced in this document. This Agreement applies to all
        users of the App and/or Site: merchants, buyers, and visitors.
      </p>
      <h2>TYPES OF USERS</h2>
      <p>
        Hereafter, in this document, persons using the App and/or Site will be
        pertained to as the following:
      </p>
      <p>
        User/s: ALL persons using the site. - Visitors, Merchants, an/or Buyers,
        whichever is referenced in the statement.
      </p>
      <p>
        Visitor/s: Those who may or may not have registered for a Qarabao
        account but are visiting a page in the App and/or Site.
      </p>
      <p>
        Merchant/s: Those who have registered for a Qarabao account and have
        filled in the required fields of the Store Info in the App and/or Site.
      </p>
      <p>
        Buyer/s: Those who have logged-in to browse products uploaded by
        Merchants and/or have inquired or transacted with a Merchant.
      </p>

      <h2>The Service</h2>
      <p>
        The Services offered by Qarabao to Merchants under this Agreement
        involve the provision of an application and a platform through which
        they can upload products, post products into different social networks,
        chat with Buyers, process orders and receive payments.
      </p>
      <p>
        On the other hand, the Services offered by Qarabao to Visitors and
        Buyers under this Agreement involve the provision of an application and
        a Site through which they can browse products, chat with Merchants,
        search for, view, order and pay for products offered by Merchants.
      </p>
      <h2>General Terms and Conditions</h2>
      <p>
        Neither Qarabao nor any of its agents or representatives shall be liable
        for any damage, loss or liability of whatsoever nature arising from the
        use, fraudulent use, misuse, or inability to use this App, Site or the
        services or content provided from and through this App and/or Site.
      </p>
      <p>
        Furthermore, Qarabao makes no representations or warranties, implied or
        otherwise, that, amongst others, the content and technology available
        from this App and/or Site are free from errors or omissions or that the
        service will be 100% uninterrupted and error free.
      </p>
      <p>
        Although the products sold via the App and/or Site may be under warranty
        provided by a Merchant, the App and the Site itself are supplied on an
        "as is" basis and have not been compiled or supplied to meet each User’s
        individual requirements. It is the User’s sole responsibility to satisfy
        himself/herself prior to accepting these TERMS AND CONDITIONS that the
        service made available from and through this App and/or Site will meet
        his/her individual requirements and be compatible with his/her hardware
        and/or software.
      </p>
      <p>
        Information, ideas and opinions expressed on this App and/or Site should
        not be regarded as professional advice or the official opinion of
        Qarabao and the Users are encouraged to consult professional advice
        before taking any course of action related to information, ideas and
        opinions expressed on this Site and/or App.
      </p>

      <h2>GOVERNING LAW AND JURISDICTION</h2>
      <p>
        These TERMS AND CONDITIONS are governed by the laws of the Philippines
        and, subject to the ‘Disputes’ clause of these TERMS AND CONDITIONS.
        Each Buyer, each Merchant and Qarabao submit to the non-exclusive
        jurisdiction of the courts of the country of the Philippines.
      </p>
      <h2>PRIVACY POLICY</h2>
      <p>
        Users acknowledge that much of the content that the Users upload to
        and/or post on the App and/or Site is submitted precisely for the
        purpose of disclosure to other Users, and therefore such information is
        not subject to any confidentiality obligation. Qarabao does not
        guarantee and/or warrant the absolute confidentiality and privacy of
        information and content which the Users uploaded and promoted/posted for
        the purpose of disclosure to other Users.
      </p>
      <p>
        Private information, such as bank account details and/or other
        payment-related information provided in connection with buying and
        selling items on the App and/or Site is processed with appropriate
        privacy, confidentiality and security protections.
      </p>
      <p>
        Save as otherwise provided in these TERMS AND CONDITIONS, Qarabao shall
        not divulge any information or documents which personally identify a
        User to any third party without the consent of the User unless the
        information and documents are required in an investigation or otherwise
        required by law.
      </p>
      <p>
        Qarabao uses cookies and other technologies to analyze the access
        history of Users, as well as to provide certain services to Users.
        Hence, Users agree that by opting to disable cookies, certain services
        may become unavailable or limited.
      </p>
      <p>
        Qarabao shall not be liable for any damage or loss caused by theft,
        hacking or fraud employed by third parties in relation with the private
        information and other payment related information of the Users beyond
        the control of Qarabao"
      </p>
      <h2>SECURITY</h2>
      <p>
        Any User who delivers or attempts to deliver any damaging code to the
        App and/or Site or attempts to gain unauthorized access to the App
        and/or Site shall be prosecuted and damages shall be claimed in the
        event that Qarabao suffers any damage or loss.
      </p>
      <p>
        The User agrees and warrants that his/her login name and password shall:
      </p>
      <p>
        (1) be used for his/her personal use only; and (2) not be disclosed to
        any third party. The User allows Qarabao to take all reasonable steps to
        ensure the integrity and security of the App, Site and service.
      </p>
      <h2>AMENDMENTS IN THE TERMS AND CONDITIONS</h2>
      <p>
        Qarabao may, in its sole discretion, change these TERMS AND CONDITIONS
        or any part thereof at any time by publishing the amended version of the
        TERMS AND CONDITIONS on the App and the Site. It is the User's
        responsibility to ensure that they are compliant with any and all
        amendments. Should the Users not agree to any part of the amendments,
        they must refrain from using the App and/or Site to sell products or
        from using the App and/or Site in any manner.
      </p>
      <p>
        Users' continued use of the App and/or Site after the publication and/
        or notice of the amended Terms and Conditions shall be construed as
        consent/approval to the amended Terms and Conditions, hence, any
        objections and/or complaints thereafter automatically waived.
      </p>
      <h2>DISPUTES</h2>
      <p>
        Qarabao merely acts as the User's, the Buyer's, or Merchant's
        facilitator in doing sell-buy transactions, hence, shall not be
        responsible and liable, in whatever manner, for any loss and/or damage
        arising from the said transaction caused by the Parties' dispute.
      </p>
      <p>
        Qarabao shall not act as an agent in connection with resolving any
        disputes between any of the parties. Any dispute regarding any Sale
        using the App and/or Site shall be handled between the Merchant and the
        Buyer and shall be referred to Arbitration
      </p>
      <p>
        Buyers, Merchants and Users may not initiate or file any action or class
        suit against Qarabao in connection with the use of Qarabao site or any
        App related to sell and buy transaction of Parties.
      </p>
      <h2>RESERVATION OF RIGHTS</h2>
      <p>
        In order to protect the interests of all Users of the App and/or Site,
        Qarabao shall maintain ultimate control over the activities taking place
        via the App and the Site. In doing so, the Services provided to the
        Users may be affected, and this clause sets out the nature and extent of
        Qarabao’s rights to do so.
      </p>
      <p>
        Site, App or Service changes: Qarabao retains the right to determine the
        content, appearance, design, functionality and all other aspects of the
        Site, App, and the Service (including the right to re-design, modify,
        remove and alter the content, appearance, design, functionality, and
        other aspects of the Site, App and the Service and any element, aspect,
        portion or feature thereof, from time to time) and shall notify the
        Users by placing notice via the Site, the App or an email.
      </p>
      <p>
        Temporary suspension of Service: Qarabao shall be entitled, at any time
        and without liability to the Users or any third party, to modify,
        expand, improve, maintain or repair the App, the Site and the Services
        notwithstanding that this may require suspending the operation of the
        App, Site and/or Services temporarily provided that Qarabao shall notify
        Users in advance of any such suspension by means of a notice displayed
        on the App, the Site or via an email, and provided further that Qarabao
        shall minimize the duration thereof, insofar as this is reasonably
        practical.
      </p>
      <p>
        Objectionable Content: Qarabao shall have the absolute right to reject
        any content that is illegal, offensive or otherwise in breach of this
        Agreement, and if the User refuses to remove any content deemed
        objectionable by Qarabao in its reasonable discretion, Qarabao may
        immediately terminate the services being provided to the User on notice
        and the User shall be liable for any fees and charges up to the date of
        such termination.
      </p>
      <h2>TERMINATION OF SALE</h2>
      <p>
        By the Merchant: Merchants are entitled to cancel any sale/s in whole or
        in part, only in the event and to the extent of any unavailability of
        stock of the relevant product/s. In such event, the Merchant must notify
        the Buyer of the fact that it is out-of-stock and issue the Buyer a full
        refund of the amount paid in respect of such product/s, if payment has
        been made.
      </p>
      <p>
        By the Buyer: The Buyer has no other rights to retract any orders made
        by him/her, or cancel any sales prior to packaging or delivery, unless
        doing so is agreed with the relevant Merchant.
      </p>
      <p>
        By Qarabao: To protect the interests of Buyers, Qarabao may use
        reasonable endeavors to scrutinize transactions between Merchants and
        Buyers to prevent fraud, and a transaction may be refused or canceled if
        Qarabao, in its sole discretion, is not fully convinced of its
        legitimacy. Accordingly, Qarabao accepts no liability that may arise as
        a result of such refusal to process any such transaction.
      </p>
      <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
      <p>
        Any and all copyright subsisting in the App and/or Site, including these
        TERMS AND CONDITIONS, vests in Qarabao and all rights not expressly
        granted are reserved in favor of Qarabao. The User may only download,
        view and print content from this App and/or Site for private and
        non-commercial purposes, unless the content has been uploaded by
        him/her.
      </p>
      <p>
        Qarabao cannot screen or edit all the content available from the App
        and/or Site and does not accept any liability for illegal, defamatory or
        obscene content. Users are encouraged to inform Qarabao of any content
        that may be offensive or illegal.
      </p>
      <p>
        All the content, trademarks and data on the App and/or Site, including,
        but not limited to, software, databases, text, graphics, icons,
        hyperlinks, private information, designs and agreements, are the
        property of or licensed to Qarabao and as such are protected from
        infringement by local and international legislation and treaties. User's
        right to use the App and/or Site shall not in any way be construed as
        assignment or giving any right to the User in relation to Qarabao's
        intellectual property rights.
      </p>
      <h2>ELECTRONIC COMMUNICATIONS</h2>
      <p>
        When Users visit the Site, use the App and/or place an order and/or send
        e-mails to Qarabao, they consent to receiving communications from
        Qarabao electronically and agree that all agreements, notices,
        disclosures and other communications sent by Qarabao satisfy any legal
        requirements, including, but not limited to, the requirement that such
        communications should be in writing.
      </p>
      <h2>HYPERLINKS, FRAMING, SPIDERS, AND CRAWLERS</h2>
      <p>
        Hyperlinks provided on this App and/or Site to non-Qarabao sites are
        provided as is and Qarabao does not necessarily agree with, edit or
        sponsor the content of such web pages.
      </p>
      <p>
        No person, business or website may frame this Site or any of the pages
        on the App and/or Site in any manner whatsoever without the express
        written permission of Qarabao.
      </p>
      <p>
        No person, business or website may use any technology to crawl and/or
        gain any information from this App and/or Site without the prior written
        permission of Qarabao.
      </p>
      <h2>TRANSLATIONS</h2>
      <p>
        If Qarabao has posted or provided a translation of the English language
        version of these TERMS AND CONDITIONS, the Users agrees that the
        translation is provided for convenience only and that the English
        language version will govern the use of the App and/or Site.
      </p>
      <h2>MERCHANT SECTION</h2>
      <ol>
        <li>
          The Merchant specifically agrees that he/she will not, directly or
          indirectly, engage in any deceptive or unethical marketing practices
          that may mislead other Users regarding any aspect of the product or
          the terms of sale hereof.
        </li>
        <li>
          The Merchant shall be solely responsible and liable for all
          information provided in relation to his/her products and hereby
          indemnify and hold harmless Qarabao from any and all kinds of claims,
          losses, damages, liabilities, judgments, or settlements, including
          attorney’s fees on a client-and-attorney basis, costs, and other
          expenses incurred by the Merchant related to or in connection with the
          description of the Merchant’s products.
        </li>
        <li>
          By posting a product, the Merchant represents and warrants to Qarabao
          and prospective Buyers that the former has the right, authority, and
          ability to sell the product and that the relevant listing details are
          accurate, current,complete and not misleading or otherwise deceptive.
        </li>
        <li>
          Qarabao is not a party to the actual sales between Merchants and
          Buyers.
        </li>
        <li>
          By entering into this Agreement and posting any product for sale, the
          Merchant agrees to complete and execute the sale. The Merchant shall
          be solely responsible for all aspects of, and actions associated with,
          any sale, including contacting the relevant Buyer directly to accept
          or reject any order placed by the Buyer, invoicing, making delivery of
          the product, issuing any refunds or discounts where relevant, and
          defending and/or resolving any sale related disputes. However, in
          order to prevent suspected fraud and protect the interests of
          customers, Qarabao has absolute right to scrutinize Merchants’
          transactions and, if not satisfied with the legitimacy of any
          transaction, in its sole discretion, refuse to process any order, or
          rescind a sale which has already been concluded including implementing
          a refund at the Merchant’s expense, and Qarabao accepts no liability
          that may arise as a result thereof.
        </li>
        <li>
          Where fraudulent activity and/or breach of this Agreement is
          suspected, Qarabao reserves the rights to delay or suspend listing of,
          or to refuse to list, or to de-list, or to require the Merchant not to
          list, any or all products, in its sole discretion, and/or Qarabao may,
          in its sole discretion, withhold for investigation, refuse to process,
          restrict shipping destinations for, stop and/or cancel any
          transaction. The Merchant shall stop and/or cancel orders if Qarabao
          asks the Merchant to do so (provided that if the Merchant has
          transferred the products to the applicable carrier or shipper, the
          Merchant shall use commercially reasonable efforts to stop and/or
          cancel delivery by such carrier or shipper). The Merchant shall refund
          any Buyer (in accordance with this Agreement) that has been charged
          for an order that Qarabao has stopped or cancelled and hereby
          authorize Qarabao to pay any such refund to the Buyer from funds held
          by Qarabao on behalf of the Merchant.
        </li>
        <li>
          The Merchant acknowledges that by not fulfilling his/her sale
          obligations to any Buyer, he/shes can be held liable by the Buyer/s
          under the terms of such sale/s, as well as by Qarabao for breach of
          this Agreement.
        </li>
        <li>
          In the event of significant User complaints related to any of the
          Merchant’s product/s, Qarabao may, in order to protect the rights of
          consumers, remove any or all of the Merchant’s products for a specific
          amount of time or indefinitely. Qarabao may also, in its sole
          discretion, suspend or terminate the Merchant’s access to the Site,
          App or the Service, or any one or more current sales immediately on
          notice in the case of suspected fraudulent activity arising from these
          User complaints, or contraventions of this Agreement, by the Merchants
          or any of the Merchant’s Buyers.
        </li>
        <li>
          If Qarabao reasonably concludes based on information available to it
          that the Merchant’s actions and/or performance in connection with the
          Services may result in Buyer disputes, chargebacks or other claims,
          then Qarabao may, in its sole reasonable discretion and without
          attracting any liability therefor, delay initiating any remittances
          and withhold any payments to be made or that are otherwise due to the
          Merchant in connection with the Services or this Agreement for a
          period of not more than 90 days following the initial date of
          suspension; or completion of any investigation(s) regarding the
          Merchant’s actions and/or performance in connection with this
          Agreement.
        </li>
      </ol>

      <h2>PAYMENTS THROUGH THE PAYMENT GATEWAYS AND SALES PROCEEDS</h2>
      <ol>
        <li>
          Payment Gateway: Qarabao offers Merchants a secure way of receiving
          payments through the Qarabao Payment Gateway.
        </li>
        <li>
          Third party payment providers: Qarabao employs third party payment
          providers to process the payments done through the Payment Gateway.
          Qarabao reserves the right to add and/or remove any payment option
          under the Payment Gateway it offers at any time, without needing to
          get the consent of the Merchant.
        </li>
        <li>
          Merchant settlement account: Sales proceeds from payments through the
          Payment Gateway are disbursed to the Merchant’s Settlement Account. It
          is the responsibility of the Merchant to make sure that the Settlement
          Account submitted to Qarabao either through the App or the Site is
          correct. Qarabao shall not be liable to the Merchant for any delay in
          the disbursement of the proceeds of Sales to the Merchant due to an
          erroneous Settlement Account.
        </li>
        <li>
          Up to 10 business day hold on sales proceeds: All proceeds of any sale
          paid through the Payment Gateway shall be deposited to the Merchant’s
          Settlement Account within 10 business days upon receipt of payment
          from the Buyer. This covers the required hold on funds of the
          respective third-party payment gateway/s Qarabao is using. Without any
          obligation to do so, Qarabao reserves the right to deposit into the
          Merchant’s Settlement Account earlier than the provisioned holding
          period.
        </li>
        <li>
          Hold on sales proceeds due to suspected fraud: Should Qarabao
          reasonably suspect that any fraudulent activity has taken place in
          relation to a specific transaction, the amount paid by a Buyer via the
          payment gateway may be placed on hold pending the outcome of Qarabao’s
          investigation in this regard. Qarabao shall be free and harmless from
          any and all kinds of liabilities whatsoever in case it exercises its
          right to place on hold any payment pending investigation. Any interest
          earnings therefrom shall not accrue to Merchant.
        </li>
        <li>
          Direct Payments to Merchants: Qarabao offers a feature for Merchants
          to accept payments from Buyers using the Merchant’s own payment
          methods. This may be Bank Deposits, Mobile Payments, Meet Ups, and
          other payment methods the Merchant submitted through the App and/or
          Site under the “Payment Details” page. However, Qarabao deems the
          Merchant solely responsible to shoulder all the risks and liabilities
          connected to this method of payment since Qarabao has no control
          whatsoever over these other payment methods, thus, Qarabao shall not
          be liable to the Merchant and/or the Buyer when a payment problem
          occurs. This includes, but not limited to: funds not deposited to
          Merchants account and Merchant not acknowledging the deposit.
          Therefore, Qarabao recommends utmost care in accepting payments
          through payment methods outside the Payment Gateway.
        </li>
        <li>
          Reimbursements: In order to preserve Qarabao’s good reputation and
          protect the rights of Buyers, Qarabao reserves the right to seek
          reimbursement from the Merchant if (a) Qarabao, in its sole
          discretion, decides to reimburse a Buyer or provides a refund to
          Buyer, (b) Merchant cannot promptly deliver the goods within the
          period specified herein that warrants such reimbursement, (c) Buyer
          discovers erroneous or duplicate transactions, (d) Buyer receives a
          chargeback from a Buyer's credit card issuer for the amount of the
          Buyer's purchase from the Merchant, or (e) Merchant fails to respond
          to any communication from a Buyer or Qarabao within 7 days. Qarabao
          may obtain reimbursement of any amounts owed by the Merchant to
          Qarabao by deducting from future sales proceeds of the Merchant,
          reversing any credits to the Merchant’s Qarabao Seller Account,
          charging the Merchant’s Settlement Account, or seeking such
          reimbursement from the Merchant by any other lawful means. The
          Merchant authorizes Qarabao to use any or all of the foregoing methods
          to seek reimbursement, including the debiting of the Merchant’s
          Settlement Account.
        </li>
      </ol>

      <h2>SHIPPING TO BUYERS</h2>
      <ol>
        <li>
          The shipping service to be used is solely in the discretion of the
          Merchant and/or the Buyer, depending on what both parties agree on.
          Likewise, the shipping fee shall be shouldered by either the Merchant
          and/or the Buyer depending on what both parties agree on. In the event
          Qarabao offers a shipping service that may employ a third-party
          courier service provider then Qarabao shall charge for the appropriate
          shipping fee.
        </li>
        <li>
          Qarabao shall not be liable for any delayed or unsuccessful shipping,
          and over-charging or non-payment of any shipping fees.
        </li>
        <li>
          The Merchant agrees to ship an item not longer than 2 business days
          upon receipt of Proof-of-Payment through the App and/or Site from the
          Buyer or Qarabao.
        </li>
        <li>
          The Merchant is solely responsible for the delivery/shipment of all
          products sold by him/her and should he/she ship/deliver to an
          incorrect address, either erroneously submitted by the Buyer to the
          Merchant or the Merchant to the courier, the Buyer and/or the Merchant
          cannot hold Qarabao liable for any costs, expense or damages that the
          Merchant may suffer as a result thereof, including any refunds paid to
          the Buyer in accordance with the provisions of this Agreement.
        </li>
      </ol>

      <h2>AMOUNTS PAYABLE BY THE MERCHANT</h2>
      <ol>
        <li>
          Transaction Fees: For any payments made by the Buyer through Qarabao’s
          Payment gateway, Qarabao shall charge a Transaction Fee based on the
          payment gateway that the buyer chose to use for payment. The amount is
          deducted from the proceeds of the Sales that is to be deposited to the
          Buyer’s Settlement Account. Therefore, the Merchant shall receive the
          proceeds of the Funds, net of the Transaction Fees involved. The
          Transaction Fee is composed of 2 fees: Payment Gateway Fee and
          Service/Handling Fee.
        </li>
        <li>
          Paid Features: Most of the features of Qarabao, the App and the Site
          are free of charge, unless expressly stipulated. Qarabao may charge
          for premium features, subscription fee, commissions, and/or referral
          fees that will be priced accordingly. Qarabao shall inform Merchants
          and Buyers of these offerings when they are available.
        </li>
      </ol>
      <h2>BILLING/PAYMENT TERMS</h2>
      <p>
        Additional batches of features may be added to the Service and made
        available to Merchants as a paid upgrade ("Paid Plan"). If the Merchant
        chooses to subscribe to a Paid Plan, the Merchant shall pay fees
        (described below) to Qarabao. Upon selection of a Paid Plan, You will
        provide Qarabao with the necessary billing information ("Billing Data").
      </p>
      <p>
        Credit cards are the only payment mechanism Qarabao will accept for
        payment of a monthly or yearly subscription fee ("Subscription Fee") for
        a Paid Plan unless otherwise stipulated or agreed upon. Paid Plans can
        be paid as either a monthly Subscription Fee or a yearly Subscription
        Fee, unless otherwise specified.
      </p>
      <p>
        If You select the Monthly Fee, the credit card that the Merchant provide
        as part of the Billing Data will be automatically and immediately billed
        on the first Business Day of each Month. The Merchant agrees that
        Qarabao may charge to the Merchant credit card all amounts due and owing
        for the Merchant’s Account on that monthly basis or upon cancellation
        (see "Termination, Breach, Suspension and Cancellation" and "Refund").
        If the Merchant selects the Yearly Fee, the credit card that the
        Merchant provides as part of the Billing Data will be automatically and
        immediately billed on the day the Merchant signs up. The Merchant agrees
        that Qarabao may charge to the Merchant’s credit card all amounts due
        and owing for the Merchant’s Account on that yearly basis unless the
        Merchant cancels the account (see the "Termination, Breach, Suspension
        and Cancellation" and "Refund" sections of these Terms of Service).
        Qarabao will contact the Merchant via electronic mail to alert the
        Merchant upon each charge. Qarabao may change prices at any time without
        prior notice, but will endeavor to provide reasonable advance notice via
        the Qarabao website and/or electronic mail. the Merchant agrees that in
        the event Qarabao is unable to collect the fees owed to Qarabao for the
        Merchant’s Account through the Merchant Subscription Fee, Qarabao may
        take any other steps it deems necessary to collect such fees from the
        Merchant and that the Merchant will be responsible for all costs and
        expenses incurred by Qarabao in connection with such collection
        activity, including collection fees, court costs and attorneys' fees.
      </p>
      <p>
        As long as the Merchant’s Account remains active and in good standing,
        the Merchant will be charged the Subscription Fee even if the Merchant
        never uses the service. the Merchant may, however, cancel Your Paid Plan
        at any time.
      </p>
      <h2>TERMINATION, BREACH, SUSPENSION AND CANCELLATION</h2>
      <p>
        If the Merchant’s Subscription Fee payment is overdue, Qarabao will
        disable the Merchant’s access to the features provided by the Paid Plan.
        Qarabao may, at its sole discretion, at any time and for any reason,
        terminate the Service, terminate this Agreement, or suspend or terminate
        the Merchant’s Account. In the event of suspension or termination, the
        Merchant account will be disabled and the Merchant may not be granted
        access to the Merchant’s Account or any files or other Content
        (including the Merchant’s User Content) contained in the Merchant
        Account, and Qarabao may delete the Merchant’s User Content, although
        residual copies of information may remain in our system for some time
        for back-up purposes. In the event of termination, Qarabao may also
        withdraw and at its discretion reallocate the public web address of the
        Merchant’s Account. If the Merchant terminates the Merchant’s Account,
        via means provided for cancellation on the Qarabao website, or via a
        phone call or electronic mail to Qarabao, and the Merchant requests that
        Qarabao deletes The Merchant’s User Content and files contained in the
        Merchant’s Account, Qarabao will make all reasonable efforts to do so.
      </p>
      <h2>REFUND</h2>
      <p>
        Qarabao provides means for Account and Paid Plan cancellation on the
        Qarabao website. If the Merchant cancels the Merchant Account within 90
        calendar days of the date of sign up, and the Merchant requests a
        refund, Qarabao will refund all payments the Merchant have made to
        Qarabao within the 90 calendar days prior to the cancellation and refund
        request.
      </p>
      <h2>BUYER SECTION</h2>
      <h3>Purchasing a Product</h3>
      <p>
        When purchasing products from a Merchant, the Buyer is contracting with
        the relevant Qarabao Merchant and not with Qarabao, and is purchasing a
        Qarabao Merchant’s product, not a Qarabao product. Qarabao’s role in
        this regard is limited to providing to Merchants the platform through
        which Merchants can market and sell their products to Buyers and receive
        payment from Buyers and through which Buyers can view, order, and pay
        for Merchant’s products.
      </p>
      <p>
        Hence, a Merchant is solely responsible for the fulfillment of all
        aspects of the Buyer’s order (including the making of timeous delivery
        of defect-free products to the Buyer) and Qarabao shall not be liable in
        any manner therefor. Qarabao’s rights and obligations under any purchase
        from a Merchant will be as agreed between the Buyer and the relevant
        Merchant, subject to the express provisions contained in this Agreement.
      </p>
      <p>
        Although Qarabao reserves the right to assist in any disputes between
        the Buyer and a Merchant in an attempt to resolve the same, Qarabao is
        not obliged to do so and any disputes must be resolved between the Buyer
        and the relevant Merchant alone.
      </p>

      <h2>STOCK AVAILABILITY</h2>
      <p>
        Stocks of all Merchant’s products on offer are limited. Should the Buyer
        have placed an order and may or may not have paid for a product which
        is, or has become, sold-out, Qarabao bears no liability for any
        inaccuracies in the information so supplied to it. Consequentyl, any
        resulting dispute thereof shall be resolved soley between the Buyer and
        the relevant Merchant.
      </p>

      <h3>Amounts Payable by the Buyer</h3>
      <p>
        Product Prices: The price of each product is displayed with the product.
      </p>
      <p>
        Shipping Fee: Delivery charges differ depending on the shipping method
        used by the Merchant and/or what the Buyer and the Merchant have agreed
        on.
      </p>
      <p>
        Taxes: It is in the sole discretion of the Merchant to collect
        applicable Tax. Qarabao assumes that, if the Merchant is a registered
        VAT vendor, all the Product Prices are already inclusive of VAT. In the
        event that legal action against the Merchant, which involves Tax
        payments, is pursued by the government, Qarabao will not be held liable,
        nor be included in any legal proceedings. In the event that Qarabao is
        held liable, Merchant shall answer for and/or reimburse, as the case may
        be, all charges, penalties and interests that may be imposed by tax
        authorities against Qarabao.
      </p>
      <h2>PAYMENTS OF ORDERS</h2>
      <p>
        Payment period: Qarabao may impose a payment window, in accordance with
        the payment provider’s terms, in paying for an order that the Buyer
        chooses to pay through the Payment Gateway. In the event that the Buyer
        pays beyond the payment window either willfully, or erroneously, Qarabao
        is not liable to reimburse the Buyer the amount that the Buyer has paid
        through the Payment Gateway. Likewise, PoketMarket and/or the Merchant
        has the right to cancel any order that has not been paid within the
        given payment period.
      </p>
      <p>
        Delay of shipment of paid orders: When a Buyer pays for an order through
        the Payment Gateway, Qarabao sends the Merchant a notice of payment
        confirmation and a proof-of-payment, which guarantees the Merchant of
        the sales proceeds. Hence, Qarabao shall not be liable for any delay in
        the shipment of orders to the Buyer due to Merchant holding the shipment
        until the sales proceeds are deposited, by Qarabao, to his/her
        Settlement Account.
      </p>
      <p>
        Direct Payments: Any payments done directly to the Merchant, either by
        bank deposit, mobile payments, or other channels may be unsecure.
        Qarabao does not have the capacity to manage any payments done through
        this method, thus Qarabao will not be liable to any damages caused by
        non-delivery of product/s or any damages resulting from the transaction
        done through this method. Customs Duties: Custom duties are the
        responsibility of the Buyer alone.
      </p>
    </div>
  )
}

export default Terms
